import { THEME_NAME, THEME_MODE } from 'foundations-theming-base/symbol';
import type {
  ThemeName,
  ThemeMode,
  Theme,
} from 'foundations-theming-base/types';

// Canary trellis-light ships with a different base value for this fwc token
// than stable, making it a reliable sentinel for channel detection at runtime
// without requiring a dedicated symbol in the theme object.
//   stable base: #D6C2D9   canary base: #FFFFFF
const CANARY_CHANNEL_SENTINEL_TOKEN = 'fwc-button-fill-secondary-default-alt';
const CANARY_CHANNEL_SENTINEL_VALUE = '#FFFFFF';
import { THEME_DATA_TAG } from './getLocalThemeSettings';

type ThemeWithMetadata = Theme & {
  [THEME_NAME]: ThemeName;
  [THEME_MODE]: ThemeMode;
};

export function getThemeMetadata(theme: Theme): ThemeWithMetadata | undefined {
  return THEME_NAME in theme && THEME_MODE in theme
    ? (theme as ThemeWithMetadata)
    : undefined;
}

export const isCanvasTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_NAME] === 'canvas';
};
export const isTrellisTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_NAME] === 'trellis';
};
export const isLightTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_MODE] === 'light';
};
export const isDarkTheme = (themeObject: Theme): boolean => {
  return getThemeMetadata(themeObject)?.[THEME_MODE] === 'dark';
};

export const isCanaryChannel = (themeObject: Theme): boolean => {
  const color = (themeObject as unknown as { color: Record<string, string> })
    .color;
  return (
    color?.[CANARY_CHANNEL_SENTINEL_TOKEN] === CANARY_CHANNEL_SENTINEL_VALUE
  );
};

export const hasThemeDataAttribute = (): boolean => {
  return document.documentElement.dataset[THEME_DATA_TAG] !== undefined;
};
